import React, { Fragment } from 'react';
import { CheckIcon } from 'lucide-react';
interface StepIndicatorProps {
  currentStep: number;
  steps: string[];
}
export function StepIndicator({
  currentStep,
  steps
}: StepIndicatorProps) {
  return <div className="bg-white border-b border-gray-200 px-6 py-4" data-id="element-694">
      <div className="flex items-center justify-between max-w-5xl mx-auto" data-id="element-695">
        {steps.map((step, index) => {
        const stepNumber = index + 1;
        const isCompleted = stepNumber < currentStep;
        const isCurrent = stepNumber === currentStep;
        const isLast = index === steps.length - 1;
        return <Fragment key={index} data-id="element-696">
              <div className="flex flex-col items-center" data-id="element-697">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-medium ${isCompleted ? 'bg-green-500 text-white' : isCurrent ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-500'}`} data-id="element-698">
                  {isCompleted ? <CheckIcon size={20} data-id="element-699" /> : stepNumber}
                </div>
                <span className={`mt-2 text-xs ${isCurrent ? 'text-blue-500 font-medium' : 'text-gray-500'}`} data-id="element-700">
                  {step}
                </span>
              </div>
              {!isLast && <div className={`flex-1 h-0.5 mx-2 ${isCompleted ? 'bg-green-500' : 'bg-gray-200'}`} style={{
            maxWidth: '80px'
          }} data-id="element-701" />}
            </Fragment>;
      })}
      </div>
    </div>;
}